import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";

export default function StudentsForm() {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = Boolean(id);

    const [list, setList] = useState([]);
    const [errors, setErrors] = useState({});
    const [sameAddress, setSameAddress] = useState(false);

    const [formData, setFormData] = useState({
        studentName: "",
        admissionNo: "",
        regdNo: "",
        session: "",
        classSection: "",
        status: "Active",

        fatherName: "",
        fatherAadharNo: "",
        motherName: "",
        motherAadharNo: "",
        dob: "",
        gender: "",
        bloodGroup: "",
        religion: "",
        socialCatagory: "",
        nationality: "",

        photo: "",

        p_address: "",
        p_city: "",
        p_state: "",
        p_pin: "",
        p_phone: "",
        p_mobile: "",

        c_address: "",
        c_city: "",
        c_state: "",
        c_pin: "",
        c_phone: "",
        c_mobile: "",
    });

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem("students")) || [];
        setList(saved);

        if (isEdit) {
            const item = saved.find((l) => String(l.id) === String(id));
            if (item) setFormData(item);
        }
    }, [id, isEdit]);

    const validate = () => {
        let err = {};

        // Basic
        if (!formData.studentName.trim()) err.studentName = "Required";
        if (!formData.admissionNo.trim()) err.admissionNo = "Required";
        if (!formData.regdNo.trim()) err.regdNo = "Required";
        if (!formData.session.trim()) err.session = "Required";
        if (!formData.classSection.trim()) err.classSection = "Required";

        if (!formData.fatherName.trim()) err.fatherName = "Required";
        if (!formData.motherName.trim()) err.motherName = "Required";

        if (!formData.dob) err.dob = "Required";
        if (!formData.gender || formData.gender === "Select") err.gender = "Select gender";
        if (!formData.bloodGroup || formData.bloodGroup === "Select") err.bloodGroup = "Required";
        if (!formData.religion || formData.religion === "Select") err.religion = "Required";
        if (!formData.socialCatagory || formData.socialCatagory === "Select") err.socialCatagory = "Required";
        if (!formData.nationality.trim()) err.nationality = "Required";

        // Aadhar (12 digits)
        if (formData.fatherAadharNo && !/^[0-9]{12}$/.test(formData.fatherAadharNo))
            err.fatherAadharNo = "Must be 12 digits";

        if (formData.motherAadharNo && !/^[0-9]{12}$/.test(formData.motherAadharNo))
            err.motherAadharNo = "Must be 12 digits";

        // Permanent Address
        if (!formData.p_address.trim()) err.p_address = "Required";
        if (!formData.p_city.trim()) err.p_city = "Required";
        if (!formData.p_state.trim()) err.p_state = "Required";

        if (!/^[0-9]{6}$/.test(formData.p_pin))
            err.p_pin = "Pin must be 6 digits";

        if (!/^[0-9]{10}$/.test(formData.p_phone))
            err.p_phone = "Phone must be 10 digits";

        if (!/^[0-9]{10}$/.test(formData.p_mobile))
            err.p_mobile = "Mobile must be 10 digits";

        // Present Address
        if (!formData.c_address.trim()) err.c_address = "Required";
        if (!formData.c_city.trim()) err.c_city = "Required";
        if (!formData.c_state.trim()) err.c_state = "Required";

        if (!/^[0-9]{6}$/.test(formData.c_pin))
            err.c_pin = "Pin must be 6 digits";

        if (!/^[0-9]{10}$/.test(formData.c_phone))
            err.c_phone = "Phone must be 10 digits";


        if (!/^[0-9]{10}$/.test(formData.c_mobile))
            err.c_mobile = "Mobile must be 10 digits";


        if (!formData.photo) {
            err.photo = "Profile photo is required";
        }

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleNumberInput = (e, field, maxLength) => {
        let value = e.target.value.replace(/\D/g, "");
        if (maxLength) value = value.slice(0, maxLength);
        setFormData({ ...formData, [field]: value });
    };

    const handleSubmit = () => {
        if (!validate()) return;

        let updatedList = [];

        if (isEdit) {
            updatedList = list.map((l) =>
                String(l.id) === String(id) ? { ...formData, id: l.id } : l
            );
        } else {
            updatedList = [{ ...formData, id: Date.now() }, ...list];
        }

        localStorage.setItem("students", JSON.stringify(updatedList));
        window.dispatchEvent(new Event("storage"));
        navigate("/admin/students");
    };

    const handleImage = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onloadend = () => {
            setFormData({ ...formData, photo: reader.result });
        };
        reader.readAsDataURL(file);
    };

    useEffect(() => {
        if (sameAddress) {
            setFormData((prev) => ({
                ...prev,
                c_address: prev.p_address,
                c_city: prev.p_city,
                c_state: prev.p_state,
                c_pin: prev.p_pin,
                c_phone: prev.p_phone,
                c_mobile: prev.p_mobile,
            }));
        }
    }, [sameAddress]);

    return (
        <div className="page">

            <style>{`
.page { background:#f4f6fb; padding:20px; }
.card { max-width:1400px; margin:auto; background:#fff; border-radius:10px; padding:30px; }

.section { margin-bottom:25px; border:1px solid #eee; border-radius:6px; }
.header { background:#0b1a4a; color:#fff; padding:10px; font-weight:600; }

.grid {
  display:grid;
  grid-template-columns:repeat(3,1fr);
  gap:50px;
  padding:20px;
}

.field { display:flex; flex-direction:column; }
.field label {
  font-size:13px;
  margin-bottom:5px;
}

.field input, .field select {
  padding:10px;
  border-radius:6px;
  border:1px solid #cbd5e1;
}

.field input.error, .field select.error {
  border-color:red;
}

.error-text {
  color:red;
  font-size:12px;
  margin-top:3px;
  min-height:14px;
}

.photo-box {
  text-align:center;
}

.photo-box img {
  width:100px;
  height:100px;
  border-radius:50%;
  object-fit:cover;
  margin-bottom:10px;
}

.actions {
  display:flex;
  justify-content:flex-end;
  gap:10px;
}

.btn {
  padding:10px 18px;
  border:none;
  border-radius:5px;
  cursor:pointer;
}

.save { background:#0b1a4a; color:#fff; }
.cancel { background:red; }
`}</style>

            <div className="card">

                <h2>{isEdit ? "Update Student" : "Add Student"}</h2>

                {/* PHOTO */}
                <div className="section">
                    <div className="header">Profile Photo</div>
                    <div className="grid">
                        <div className="photo-box">
                            {formData.photo && <img src={formData.photo} alt="" />}
                            <input type="file" onChange={handleImage} />
                            <span className="error-text">{errors.photo}</span>
                        </div>
                    </div>
                </div>

                {/* BASIC INFO */}
                <div className="section">
                    <div className="header">Basic Info</div>
                    <div className="grid">

                        <div className="field">
                            <label>Student Name</label>
                            <input value={formData.studentName}
                                onChange={e => setFormData({ ...formData, studentName: e.target.value })}
                                className={errors.studentName ? "error" : ""} />
                            <span className="error-text">{errors.studentName}</span>
                        </div>

                        <div className="field">
                            <label>Admission No</label>
                            <input value={formData.admissionNo}
                                onChange={e => setFormData({ ...formData, admissionNo: e.target.value })}
                                className={errors.admissionNo ? "error" : ""} />
                            <span className="error-text">{errors.admissionNo}</span>
                        </div>

                        <div className="field">
                            <label>Regd No</label>
                            <input value={formData.regdNo}
                                onChange={e => setFormData({ ...formData, regdNo: e.target.value })}
                                className={errors.regdNo ? "error" : ""} />
                            <span className="error-text">{errors.regdNo}</span>
                        </div>

                        <div className="field">
                            <label>Session</label>
                            <input value={formData.session}
                                onChange={e => setFormData({ ...formData, session: e.target.value })}
                                className={errors.session ? "error" : ""} />
                            <span className="error-text">{errors.session}</span>
                        </div>

                        <div className="field">
                            <label>Class Section</label>
                            <input value={formData.classSection}
                                onChange={e => setFormData({ ...formData, classSection: e.target.value })}
                                className={errors.classSection ? "error" : ""} />
                            <span className="error-text">{errors.classSection}</span>
                        </div>

                        <div className="field">
                            <label>Status</label>
                            <select value={formData.status}
                                onChange={e => setFormData({ ...formData, status: e.target.value })}>
                                <option>Select</option>
                                <option>Active</option>
                                <option>Inactive</option>
                            </select>
                        </div>

                        <div className="field">
                            <label>Father Name</label>
                            <input value={formData.fatherName}
                                onChange={e => setFormData({ ...formData, fatherName: e.target.value })}
                                className={errors.fatherName ? "error" : ""} />
                            <span className="error-text">{errors.fatherName}</span>
                        </div>

                        <div className="field">
                            <label>Father Aadhar No</label>
                            <input
                                value={formData.fatherAadharNo}
                                onChange={(e) => handleNumberInput(e, "fatherAadharNo", 12)}
                            />
                            <span className="error-text">{errors.fatherAadharNo}</span>
                        </div>

                        <div className="field">
                            <label>Mother Name</label>
                            <input value={formData.motherName}
                                onChange={e => setFormData({ ...formData, motherName: e.target.value })}
                                className={errors.motherName ? "error" : ""} />
                            <span className="error-text">{errors.motherName}</span>
                        </div>

                        <div className="field">
                            <label>Mother Aadhar No</label>
                            <input
                                value={formData.motherAadharNo}
                                onChange={(e) => handleNumberInput(e, "motherAadharNo", 12)}
                            />
                            <span className="error-text">{errors.motherAadharNo}</span>
                        </div>

                        <div className="field">
                            <label>DOB</label>
                            <input type="date" value={formData.dob}
                                onChange={e => setFormData({ ...formData, dob: e.target.value })}
                            />
                            <span className="error-text">{errors.dob}</span>
                        </div>

                        <div className="field">
                            <label>BloodGroup</label>
                            <select value={formData.bloodGroup}
                                onChange={e => setFormData({ ...formData, bloodGroup: e.target.value })}>
                                <option>Select</option>
                                <option>A+</option>
                                <option>A-</option>
                                <option>B+</option>
                                <option>B-</option>
                                <option>AB+</option>
                                <option>AB-</option>
                                <option>O+</option>
                                <option>O-</option>
                            </select>
                            <span className="error-text">{errors.bloodGroup}</span>
                        </div>

                        <div className="field">
                            <label>Gender</label>
                            <select value={formData.gender}
                                onChange={e => setFormData({ ...formData, gender: e.target.value })}>
                                <option>Select</option>
                                <option>Male</option>
                                <option>Female</option>
                            </select>
                            <span className="error-text">{errors.gender}</span>
                        </div>

                        <div className="field">
                            <label>Religion</label>
                            <select value={formData.religion}
                                onChange={e => setFormData({ ...formData, religion: e.target.value })}>
                                <option>Select</option>
                                <option>Hindu</option>
                                <option>Muslim</option>
                                <option>Christianity</option>
                                <option>Sikh</option>
                                <option>Other</option>
                            </select>
                            <span className="error-text">{errors.religion}</span>
                        </div>

                        <div className="field">
                            <label>Social Catagory</label>
                            <select value={formData.socialCatagory}
                                onChange={e => setFormData({ ...formData, socialCatagory: e.target.value })}>
                                <option>Select</option>
                                <option>General</option>
                                <option>OBC</option>
                                <option>SC</option>
                                <option>ST</option>
                                <option>Other</option>
                            </select>
                            <span className="error-text">{errors.socialCatagory}</span>
                        </div>

                        <div className="field">
                            <label>Nationality </label>
                            <input value={formData.nationality}
                                onChange={e => setFormData({ ...formData, nationality: e.target.value })}
                                className={errors.nationality ? "error" : ""} />
                            <span className="error-text">{errors.nationality}</span>
                        </div>

                    </div>
                </div>

                {/*  Permanent Address */}
                <div className="section">
                    <div className="header"> Permanent Address</div>
                    <div className="grid">

                        <div className="field">
                            <label> Address</label>
                            <input value={formData.p_address}
                                onChange={e => setFormData({ ...formData, p_address: e.target.value })}
                                className={errors.p_address ? "error" : ""} />
                            <span className="error-text">{errors.p_address}</span>
                        </div>

                        <div className="field">
                            <label>City</label>
                            <input value={formData.p_city}
                                onChange={e => setFormData({ ...formData, p_city: e.target.value })}
                                className={errors.p_city ? "error" : ""} />
                            <span className="error-text">{errors.p_city}</span>
                        </div>

                        <div className="field">
                            <label>State</label>
                            <input value={formData.p_state}
                                onChange={e => setFormData({ ...formData, p_state: e.target.value })}
                                className={errors.p_state ? "error" : ""} />
                            <span className="error-text">{errors.p_state}</span>
                        </div>

                        <div className="field">
                            <label>Pincode</label>
                            <input
                                value={formData.p_pin}
                                onChange={(e) => handleNumberInput(e, "p_pin", 6)}
                            />
                            <span className="error-text">{errors.p_pin}</span>
                        </div>

                        <div className="field">
                            <label>Phone</label>
                            <input
                                value={formData.p_phone}
                                onChange={(e) => handleNumberInput(e, "p_phone", 10)}
                                className={errors.p_phone ? "error" : ""}
                            />
                            <span className="error-text">{errors.p_phone}</span>
                        </div>

                        <div className="field">
                            <label>Mobile</label>
                            <input
                                value={formData.p_mobile}
                                onChange={(e) => handleNumberInput(e, "p_mobile", 10)}
                                className={errors.p_mobile ? "error" : ""}
                            />
                            <span className="error-text">{errors.p_mobile}</span>
                        </div>

                    </div>
                </div>

                {/*  Present Address */}
                <div className="section">
                    <div className="header"> Present Address </div>
                    <div className="grid">

                        <div className="field">
                            <label> Address</label>
                            <input value={formData.c_address}
                                onChange={e => setFormData({ ...formData, c_address: e.target.value })}
                                className={errors.c_address ? "error" : ""} />
                            <span className="error-text">{errors.c_address}</span>
                        </div>

                        <div className="field">
                            <label>City</label>
                            <input value={formData.c_city}
                                onChange={e => setFormData({ ...formData, c_city: e.target.value })}
                                className={errors.c_city ? "error" : ""} />
                            <span className="error-text">{errors.c_city}</span>
                        </div>

                        <div className="field">
                            <label>State</label>
                            <input value={formData.c_state}
                                onChange={e => setFormData({ ...formData, c_state: e.target.value })}
                                className={errors.c_state ? "error" : ""} />
                            <span className="error-text">{errors.c_state}</span>
                        </div>

                        <div className="field">
                            <label>Pincode</label>
                            <input value={formData.c_pin}
                                onChange={e => setFormData({ ...formData, c_pin: e.target.value })}
                                className={errors.c_pin ? "error" : ""} />
                            <span className="error-text">{errors.c_pin}</span>
                        </div>

                        <div className="field">
                            <label>Phone</label>
                            <input value={formData.c_phone}
                                onChange={e => setFormData({ ...formData, c_phone: e.target.value })}
                                className={errors.c_phone ? "error" : ""} />
                            <span className="error-text">{errors.c_phone}</span>
                        </div>

                        <div className="field">
                            <label>Mobile</label>
                            <input value={formData.c_mobile}
                                onChange={e => setFormData({ ...formData, c_mobile: e.target.value })}
                                className={errors.c_mobile ? "error" : ""} />
                            <span className="error-text">{errors.c_mobile}</span>
                        </div>

                        <div style={{ padding: "10px 15px" }}>
                            <label>
                                <input
                                    type="checkbox"
                                    checked={sameAddress}
                                    onChange={(e) => setSameAddress(e.target.checked)}
                                />
                                Same as Permanent Address
                            </label>
                        </div>
                    </div>
                </div>

                {/* ACTIONS */}
                <div className="actions">
                    <button className="btn save" onClick={handleSubmit}>
                        {isEdit ? "Update" : "Save"}
                    </button>

                    <button className="btn cancel" onClick={() => navigate("/admin/students")}>
                        Cancel
                    </button>
                </div>

            </div>
        </div>
    );
}